var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPuppet175Dbadf64126Ccf5A57C5591A4193Bf4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 880,
    viewBox: "1.1 1.1 600.1 211.9",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m58.5 58.4h48v48h-48z",
    fill: "#ffb600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58.5 58.4h48v48h-48z",
    fill: "none",
    stroke: "#ffb600",
    strokeMiterlimit: 10,
    strokeWidth: 2.17
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m49.1 115.7h-48v48h48zm-15.9 32h-16v-16h16z",
    fill: "#ffb600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m49.1 115.7h-48v48h48zm-15.9 32h-16v-16h16z",
    fill: "none",
    stroke: "#ffb600",
    strokeMiterlimit: 10,
    strokeWidth: 2.17
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m28.838 39.968 11.172-11.172 28.92 28.92-11.172 11.172z",
    fill: "#ffb600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m28.838 39.968 11.172-11.172 28.92 28.92-11.172 11.172z",
    fill: "none",
    stroke: "#ffb600",
    strokeMiterlimit: 10,
    strokeWidth: 2.169978
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m38.606 115.05 19.304-19.303 11.101 11.101-19.303 19.304z",
    fill: "#ffb600"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m38.606 115.05 19.304-19.303 11.101 11.101-19.303 19.304z",
    fill: "none",
    stroke: "#ffb600",
    strokeMiterlimit: 10,
    strokeWidth: 2.169978
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m49.1 1.1h-48v48h48zm-15.9 32h-16v-16h16z",
    fill: "#ffb600"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m49.1 1.1h-48v48h48zm-15.9 32h-16v-16h16z",
    fill: "none",
    stroke: "#ffb600",
    strokeMiterlimit: 10,
    strokeWidth: 2.17
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m160.9 158.4c2.6 5.4 8.3 9 14.6 9 11.6 0 18.6-9.4 18.6-21.7 0-12.5-6.9-21.8-18.6-21.8-6.4 0-12 3.8-14.6 9zm0 54.6h-21.5v-106.1h21.5v6.4c3.5-4.2 11.1-8.1 19.4-8.1 22.5 0 35.4 18.7 35.4 40.6 0 21.8-12.8 40.4-35.4 40.4-8.3 0-16-4-19.4-8.1zm132.8-28.6h-21.5v-7.1c-4.3 4.9-11.8 8.8-20.8 8.8-17.3 0-27.2-11.4-27.2-28.6v-50.6h21.5v46.3c0 8.2 4 13.7 12.5 13.7 6.6 0 12.3-4 13.9-10.7v-49.2h21.7v77.4zm35.8-26c2.6 5.4 8.3 9 14.6 9 11.6 0 18.6-9.4 18.6-21.7 0-12.5-6.9-21.8-18.6-21.8-6.4 0-12 3.8-14.6 9zm0 54.6h-21.5v-106.1h21.5v6.4c3.5-4.2 11.1-8.1 19.4-8.1 22.5 0 35.4 18.7 35.4 40.6 0 21.8-12.8 40.4-35.4 40.4-8.3 0-16-4-19.4-8.1zm85.6-54.6c2.6 5.4 8.3 9 14.6 9 11.6 0 18.6-9.4 18.6-21.7 0-12.5-6.9-21.8-18.6-21.8-6.4 0-12 3.8-14.6 9zm0 54.6h-21.5v-106.1h21.5v6.4c3.5-4.2 11.1-8.1 19.4-8.1 22.5 0 35.4 18.7 35.4 40.6 0 21.8-12.8 40.4-35.4 40.4-8.3 0-16-4-19.4-8.1zm81.4-75.8h30c-.2-8.2-5-14.6-13.9-14.6-8.3 0-14.2 5.1-16.1 14.6m50.6 21.9c-2.8 16.5-14.9 27.1-34.3 27.1-22.5 0-37.6-16.5-37.6-40.4 0-23.4 15.6-40.6 37.3-40.6 22.7 0 35.2 15.8 35.2 38.5v6.6h-51.7c.7 11.6 7.3 18.6 16.8 18.6 7.3 0 12.7-3.1 14.4-9.7h19.9zm14.6-34.9h-11.8v-17.3h11.8v-21h21.3v21h17v17.3h-17v34c0 6.1 3.3 8.8 8.8 8.8 3.3 0 6.9-1 9.4-2.6v19.1c-2.9 1.6-8.2 2.4-13.9 2.4-15.8 0-25.7-7.8-25.7-25v-36.7z",
    fill: "#0e1821"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuppet175Dbadf64126Ccf5A57C5591A4193Bf4);
export default __webpack_public_path__ + "static/media/puppet-1.75dbadf64126ccf5a57c5591a4193bf4.75dbadf64126ccf5a57c5591a4193bf4.svg";
export { ForwardRef as ReactComponent };